import { Injectable } from '@angular/core';

import { DataService } from '@app/services/root/data.service';
import { UTILITY_URL } from '@app/constants';
@Injectable({
    providedIn: 'root'
})
export class UtilityService {
    constructor(private dataService: DataService) { }

    public async getClientNetInformation() {
        const env: any = window['__env'];
        let promise = null;
        // This is to allow the machine to run locally the application it will overwrite the route
        // to the client utility to the test environment.
        // not working at the moment @ronald.lobo to find why
        // if (env.environment === 'dev' || env.environment === 'development') {
        promise = new Promise<any>((resolve) => {
            resolve({ internal: true, ip: '', userAgent: '' });
        });
        // } else {
        //     promise =  this.dataService.get(UTILITY_URL)
        //     .then(response => response);
        // }
        return promise;
    }
}
